import { commonsApiClient } from "./client";
import { FetchedRecipe, RecipeApiResponse } from "../types/recipe";
import { UserContributions } from "../types";

/**
 * Recipe API service for managing recipe-related operations
 */
export const recipesApi = {
  /**
   * Fetches a recipe by ID
   * @param recipeId - The ID of the recipe to fetch
   * @returns Promise resolving to recipe data
   */
  async getRecipe(recipeId: string): Promise<RecipeApiResponse> {
    return await commonsApiClient.get<RecipeApiResponse>(
      `/api/materials-database/recipes/${recipeId}`
    );
  },

  /**
   * Fetches all contributions (recipes and ingredients) for a user.
   * @param userId - The ID of the user.
   * @returns Promise resolving to an object containing recipes and ingredients.
   */
  async getUserContributions(userId: string): Promise<UserContributions> {
    const response = await commonsApiClient.get<UserContributions>(
      `/api/user/${userId}/recipes`
    );
    return response;
  },
};

/**
 * Fetches featured recipes
 * @returns Promise resolving to an array of featured recipes
 */
export async function getFeaturedRecipes(): Promise<FetchedRecipe[]> {
  return await commonsApiClient.get<FetchedRecipe[]>("/api/recipes/featured");
}
